module.exports = __webpack_public_path__ + "static/media/galleryArrow.be237328.svg";